import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor, _BlockingProgressAction;
/*
 *                     NOTICE
 *            COPYRIGHT 2020 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { LayerManager } from "abreact/incubator/ui/manager/LayerManager";
import { ProgressActionBase } from "abreact/progress/manager/ProgressActionBase";
import { makeObservable, observable, runInAction, when } from "mobx";

/**
 * The return value from a "report" function
 */

export let BlockingProgressAction = (_class = (_BlockingProgressAction = class BlockingProgressAction extends ProgressActionBase {
  get blocking() {
    return true;
  }
  get title() {
    return this.blockingProgressAction.title;
  }
  get report() {
    return this.blockingProgressAction.report;
  }
  get steps() {
    return this.blockingProgressAction.steps;
  }
  get reportInterval() {
    return this.blockingProgressAction.reportInterval;
  }
  get onCancel() {
    return this.blockingProgressAction.onCancel != null ? async taskName => {
      runInAction(() => this._cancelling = true);
      return this.blockingProgressAction.onCancel?.(taskName);
    } : undefined;
  }
  get cancelling() {
    return this._cancelling;
  }
  constructor(blockingProgressAction) {
    super(blockingProgressAction);
    _initializerDefineProperty(this, "_cancelling", _descriptor, this);
    // private static NEXT_COUNTER: number = 0;
    //
    // private _counter: number = BlockingProgressAction.NEXT_COUNTER++;
    _defineProperty(this, "blockingProgressAction", void 0);
    _defineProperty(this, "timeToRun", 0);
    makeObservable(this);
    this.blockingProgressAction = blockingProgressAction;
  }

  // noinspection JSUnusedLocalSymbols
  log(msg) {
    // console.log(`*** [${new Date().toISOString()}] BlockingProgressAction_${this.blockingProgressAction.name}: ${msg}`);
  }

  /**
   * Show this blocking progress action as one of the tasks in the progress manager.
   * @param execFunc (optional) callback that must resolve to hide the action.
   * If execFunc is not provided, then the caller must call {@link hideUI()} to hide the action.
   */
  async show(execFunc) {
    if (!LayerManager.isDefaultLayerGroupUsable) {
      this.log(`No LayerManager. Executing without showing anything`);
      if (execFunc == null) {
        // two casts are to make the compiler happy.S
        return null;
      }
      // noinspection UnnecessaryLocalVariableJS
      const immediateValue = await execFunc();
      return immediateValue;
    }
    const initialDelay = this.blockingProgressAction.initialDelay !== undefined ? this.blockingProgressAction.initialDelay : BlockingProgressAction.DEFAULT_INITIAL_DELAY;

    // Initial delay of 0 means show immediately (after the blocker)
    // this._state could now be "hidden" if hideUI() called while waiting
    this.log(`show: Showing`);
    this.showUI({
      displayDelay: initialDelay
    });
    if (execFunc == null) {
      // two casts are to make the compiler happy
      return null; // No call to hideUI!  It is up to clients to call it.
    }

    // We wrapped this in a try/catch because of the hideOnError property - if that's set,
    // then if there's an error, we'll need to catch the error, hide the progress indicator,
    // and then rethrow the error.
    try {
      this.log(`show: Executing function`);
      const value = await execFunc();
      this.log(`show: Done with function`);
      this.log(`show: Hiding`);
      this.hideUI();
      this.log(`show: Hidden`);
      return value;
    } catch (err) {
      this.log(`show: caught error ${err}`);
      if (this.blockingProgressAction.hideOnError !== false)
        // treat undefined as true
        {
          this.log(`show: Hiding because of error`);
          this.hideUI();
          this.log(`show: Hidden because of error`);
        }
      this.log(`show: rethrowing error`);
      throw err;
    }
  }

  // Override visibility for handle class below.
  hideUI() {
    super.hideUI();
  }
}, _defineProperty(_BlockingProgressAction, "DEFAULT_REPORT_INTERVAL", 1000), _defineProperty(_BlockingProgressAction, "DEFAULT_INITIAL_DELAY", 750), _BlockingProgressAction), _descriptor = _applyDecoratedDescriptor(_class.prototype, "_cancelling", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _class);

/**
 * A wrapper class that allows a BlockingProgressAction to be treated like a popup handle.
 * Used to make callers of AbPopup think a popup has been shown.
 */
export class BlockingProgressActionPopupHandle {
  constructor(bpa) {
    _defineProperty(this, "action", void 0);
    this.action = bpa;
  }
  get untilClosed() {
    return when(() => !this.action.showing);
  }
  close() {
    this.action.hideUI();
  }
}
//# sourceMappingURL=BlockingProgressAction.js.map
